import { ViewModel, ViewModelFieldName } from "../Engine/Core/CoreTypes";
import { iterateEntries } from "../../../Common/IterableUtils";
import { StringInnerViewModel } from "../../../Common/CandyApiClient/Types/GetInner/ServerRawResponse";

import { ValueOf } from "./TypingUtils";
import { splitLastOccurrence } from "./StringHelpers";

export interface StringViewModel {
    [viewModelField: string]: string;
}
export interface PathStringViewModel {
    [path: string]: StringViewModel;
}

const parseStringValue = (value: string, field: ViewModelFieldName): ValueOf<ViewModel> => {
    const fieldsToParse: ViewModelFieldName[] = [
        "children",
        "error",
        "warning",
        "disabled",
        "visible",
        "disabledSending",
        "autoFlag",
        "errorsCount",
        "warningsCount",
        "normalized",
        "emptyUnitsVisible",
        "pencilOpened",
        "ignoreAutoFlag",
    ];
    if (fieldsToParse.includes(field)) {
        return JSON.parse(value) as ValueOf<ViewModel>;
    }

    return value;
};

export const parseStringViewModel = (stringViewModel: StringViewModel): ViewModel => {
    const viewModel: ViewModel = {};
    for (const [viewModelField, viewModelValue] of iterateEntries(stringViewModel)) {
        // @ts-ignore
        viewModel[viewModelField] = parseStringValue(viewModelValue, viewModelField as ViewModelFieldName);
    }
    return viewModel;
};

export const getPathsViewModels = (model: StringInnerViewModel): PathStringViewModel => {
    const pathsViewModels: PathStringViewModel = {};

    for (const [fieldName, fieldValue] of iterateEntries(model)) {
        const [path, viewModelFieldName] = splitLastOccurrence(fieldName, ".");

        if (!viewModelFieldName) {
            continue;
        }

        if (pathsViewModels[path] == undefined) {
            pathsViewModels[path] = {};
        }
        // @ts-ignore
        pathsViewModels[path][viewModelFieldName] = fieldValue;
    }

    return pathsViewModels;
};
